export const environment = {
  production: false,
  baseUrl: 'https://avis2qa.enetelsolutions.com/avis2/api',
  webSocketUrl: 'wss://avis2qa.enetelsolutions.com/avis2/ws/socket',
};
